module.exports = __webpack_public_path__ + "static/media/contratosecundario2027.6f522102.pdf";